export default "__VITE_ASSET__BS8h$HFQ__"